import { styled } from 'styled-components';

export const DesktopSearchBarInputsForm = styled.form<{
  $isTabbing?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
`;

export const DesktopSearchBarFieldsHolder = styled.div`
  display: flex;
  flex: 10;
  align-items: center;
  gap: 12px;
`;
